module.exports = __webpack_public_path__ + "static/img/4.6bff6d8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/11/zh/4.png
// module id = THX/
// module chunks = 0